import { create } from 'zustand';

export const useFavoritesStore = create((set) => ({
  favorites: [],

  addFavorite: (product) =>
    set((state) => {
      const exists = state.favorites.find((item) => item._id === product._id);
      if (exists) {
        return state;
      }
      return { favorites: [...state.favorites, product] };
    }),

  removeFavorite: (productId) =>
    set((state) => ({
      favorites: state.favorites.filter((item) => item._id !== productId),
    })),

  isFavorite: (productId) => {
    const state = useFavoritesStore.getState();
    return state.favorites.some((item) => item._id === productId);
  },

  clearFavorites: () => set({ favorites: [] }),
}));
